import BlogsForm from "../components/layout/blogs/BlogsForm";

const BlogsPage = (props) => {
  return <BlogsForm content={props.content} />;
};

export default BlogsPage;
